import {withStyles} from '@material-ui/core/styles';
import * as React from 'react';
import * as TodoActions from '@services/todos/todo.action';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@components/common/iconButton/iconButton.component';

import {connect} from 'react-redux';
import {ITodo, TODO_TYPE} from '@app-types/websocket/todo.types';
import {IFamilyMember} from '@app-types/websocket/family.types';
import EditTodoDialog from './EditTodoDialog';
import {FamilyMemberType} from '@services/family/family.constants';
import TranslateNew from '@translate/TranslateNew';
import {TodoButtonStyle as styles} from './TodoButton.style';


const tn: TranslateNew = TranslateNew.getInstance();



interface IProps {
  classes: any;
  hide: boolean;
  style?: React.CSSProperties;
}

interface IState {
  openAddTodoModal: boolean;
}


class TodoButton extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      openAddTodoModal: false,
    };
  }


  public render() {

    const style:React.CSSProperties = JSON.parse(JSON.stringify(this.props.style?this.props.style:{}));
    if (this.props.hide) {
      style.scale = 0;
      style.pointerEvents = 'none';
    }
    if (this.state.openAddTodoModal) {
      style.pointerEvents = 'none';
      style.scale = 0;
    }

    return (
      <>
        <IconButton classes={{root: this.props.classes.fab}} style={style}
             aria-label={tn.lang.addTodo} disabled={this.props.hide || this.state.openAddTodoModal}
             onClick={() => this.setState({openAddTodoModal: true})}>
          <AddIcon style={{fontSize:'42px'}}/>
        </IconButton>
        <EditTodoDialog
          open={this.state.openAddTodoModal}
          close={() => this.handleClose()}
          type={TODO_TYPE.NORMAL}
        />
      </>
    );
  }

  private handleClose() {
    this.setState({openAddTodoModal: false});
  }
}

function mapStateToProp(state: any) {

  const todos: ITodo[] = state.todo.todos;
  return {
    todos: todos.filter((todo: ITodo) => todo.type === TODO_TYPE.NORMAL),
    family: state.family.family.filter((member: IFamilyMember) => member.role === FamilyMemberType.CHILD
      || member.role === FamilyMemberType.PARENT || member.role === FamilyMemberType.VIEWER),
  };
}

const mapDispatchToProps = {
  completeTodo: TodoActions.completeTodo,
  hideTodo: TodoActions.hideTodo,
  seenTodo: TodoActions.seenTodo,
};

export default connect(mapStateToProp, mapDispatchToProps)(withStyles(styles)(TodoButton));



// WEBPACK FOOTER //
// ./src/components/todo/TodoButton.tsx